import '@babel/polyfill'
import App from './App.vue'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import store from './store'

Vue.use(VueAxios, axios)

/* eslint-disable no-new */
new Vue({
  el: '#find-my-photos-app',
  mounted: function () {
    this.$store.commit('setViewModel', window.pageData.findMyPhotos.viewModel)
  },
  render: function (h) { return h(App) },
  store: store
})



// WEBPACK FOOTER //
// ./WebResources/vue/find-my-photos/main.js